// extracted by mini-css-extract-plugin
export default {"typography":"typography_typography__5J9UP"};